<nb-card>
  <nb-card-body>
    <div  [innerHTML]="text"></div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="dismiss(true)" i18n="@@Ok">OK</button>
   </nb-card-footer>
</nb-card>
